<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم تحویل دستگاه ها</h5>

    <button type="button" (click)="openModal_Customer(templateCustomer)" class="btn btn-warning"
      style="margin-left: 5px;"> جستجوی مشتری
      <i class="fa fa-vcard"></i> </button>


    <br />
    <br />

    <div [hidden]="Data_Seleted_Customer.id==0">

      <form>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">نام مشتری </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.name}}" />
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">کد مشتری بهفا </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.code}}" />
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> نوع تحویل به مشتری </label>
            <select [(ngModel)]="Inperson" name="Inperson" class="custom-select">
              <option value="-1">انتخاب کنید</option>
              <option value="1">حضوری</option>
              <option value="0">تیپاکس</option>
            </select>
          </div>
        </div>

      </form>

      <div [hidden]="Inperson=='-1'">

        <form [hidden]="Inperson!='1'">
          <div class="row">

            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> گیرنده </label>
              <select [(ngModel)]="PersoneType" name="PersoneType" class="custom-select">
                <option value="0">انتخاب کنید</option>
                <option value="1">نماینده</option>
                <option value="2">پیک موتوری</option>
                <option value="3">آژانس</option>
              </select>
            </div>

            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> نام </label>
              <input type="text" [(ngModel)]="InpersoneName" name="InpersoneName" class="form-control"
                placeholder="اینجا تایپ کنید ... " />
            </div>
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> شماره تماس </label>
              <input type="text" [(ngModel)]="InpersonePhone" name="InpersonePhone" class="form-control"
                placeholder="اینجا تایپ کنید ... " />
            </div>
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> کدملی</label>
              <input type="number" class="form-control" [(ngModel)]="InpersoneCodeMeli" name="InpersoneCodeMeli"
                class="form-control" placeholder="اینجا تایپ کنید ... " />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> توضیحات تحویل به مشتری </label>
              <textarea class="form-control" [(ngModel)]="InpersoneDsc" name="InpersoneDsc" class="form-control"
                placeholder="اینجا تایپ کنید ... "></textarea>
            </div>
          </div>

        </form>

        <form [hidden]="Inperson!='0'">
          <div class="row">
            <div class="form-group col-md-4">
              <label for="exampleInputEmail1"> کد رهگیری </label>
              <input type="text" [(ngModel)]="CodeRahgiri" name="CodeRahgiri" class="form-control"
                placeholder="اینجا تایپ کنید ... " />
            </div>

            <div class="form-group col-md-4">
              <label for="exampleInputEmail1"> تاریخ تحویل به پست</label>
              <input type="text" #datepickerInputDeliver placeholder="اینجا تایپ کنید ..." class="form-control" />
              <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
                [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputDeliver">
              </ng-persian-datepicker>
            </div>

            <div class="form-group col-md-4">
              <label for="exampleInputEmail1">کاشناس مسئول</label>
              <select class="custom-select" [(ngModel)]="KarshnasMasol" name="KarshnasMasol">
                <option value="0">انتخاب کنید</option>
                <option *ngFor="let item of DataList_KarshnasMasol" [value]="item.id">{{item.name}}</option>

              </select>
            </div>
          </div>


        </form>

        <br />
        <br />

        <ul>
          <li>قبل از اسکن در کادر مربوطه کلیک کنید</li>
          <li>برای بررسی کد اسکن شده می توانید کلیک Enter را فشار دهید</li>
          <li>برای پاک کردن فرم مربوطه می توانید کلیک ESC را فشار دهید</li>

        </ul>

        <br />
        <br />

        <form>


          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> قبل از اسکن QR Code در کادر پایین کلیک کنید <i
                  class="fa fa-arrow-down"></i>
              </label>
              <input #QRCodeInputDelivery type="text" (keyup.enter)="QRCodeInputDelivery_Enter()"
                (keyup.esc)="QRCodeInputDelivery_Esc()"
                style="font-family: Arial, Helvetica, sans-serif;background-color: #dfdddd;"
                class="form-control EnglishClm" placeholder="اینجا کلیک کنید ...">
              <p [hidden]="!Procssing"> لطفا صبر نمائید ... <i class="fa fa-spin fa-refresh"></i> </p>

            </div>
          </div>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />

          <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeChangeDelivery(datepickerInputDeliver.value)" type="button"
            [disabled]="Info_Delivery_List.length==0" class="btn btn-success"
            style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت تحویل دستگاه های اسکن شده </button>

          <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeInputDelivery_Enter()" type="button"
            class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> بررسی شناسه دستگاه
          </button>

          <button *ngIf="!Procssing && FormSubmitted" (click)="ResetForm()" type="button" class="btn btn-danger"
            style="margin-left: 5px;"><i class="fa  fa-recycle"></i> شروع مججد </button>


        </form>

        <br />
        <br />

        <div class="row" *ngIf="Info_Delivery_List.length>0">
          <div class="form-group col-md-12">
            <div class="table-responsive">
              <table class="mb-0 table table-bordered table-3 text-center table-striped">
                <thead style="background-color: #489b39; color: white;">
                  <tr>
                    <th>#</th>
                    <th>کد دستگاه</th>
                    <th>سریال دستگاه</th>
                    <th *ngIf="!FormSubmitted">QR Code</th>
                    <th *ngIf="FormSubmitted">پیغام سیستم</th>
                    <th>امکانات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of Info_Delivery_List">
                    <td>{{Info_Delivery_List.indexOf(item)+1}}</td>
                    <td>{{item.code}}</td>
                    <td>{{item.title}}</td>
                    <td *ngIf="item.id==0">{{item.dsc}}</td>
                    <td *ngIf="item.id>0" style="color: green;">{{item.dsc}}</td>
                    <td *ngIf="item.id<0" style="color: red;">{{item.dsc}}</td>
                    <td>
                      <button *ngIf="!FormSubmitted" (click)="Info_Delivery_Remove(Info_Delivery_List.indexOf(item))"
                        class="btn btn-danger"><i class="fa fa-remove"></i> حذف </button>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</div>

<ng-template #templateCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات مشتری </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Customer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">نام مشتری </label>
          <input type="text" class="form-control" (keyup)="ReadData_Customer_KeySearch()"
            [(ngModel)]="Search_CodeName_Customer_Table" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>کد مشتری بهفا</th>
              <th>نام مشتری</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Customer).length
                      }">
              <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.name}}</td>
              <td (click)="Set_Selected_Customer_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingCustomer" type="button" (click)="ReadData_Customer()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">بستن</button>
  </div>
</ng-template>
